module.exports = __webpack_public_path__ + "static/media/java.228de75a.svg";